export default {
    methods: {
        setListener (element, callback) {
            element.addEventListener('click', (e) => callback(e));
        },
        removeListener (element, event, callback) {
            element.removeEventListener(event, callback);
        }
    }
};
